import React, { Component } from 'react'
import axios from 'axios'
import Auth from '../../Modules/Auth'
import MyPageForm from '../../Components/User/MyPageForm'
import './MyPage.scss'
import { withCookies, Cookies } from 'react-cookie'
import HeaderMenu from '../../Components/Commons/HeaderMenu'
import HeaderProject from '../../Components/Commons/HeaderProject'

class MyPage extends Component {
    constructor(props, context) {
        super(props, context)

        this.state = {
            user: {
                email: '',
                name: '',
                password: '',
                passwordConfirm: '',
                phoneNumber: '',
                thumbnailUrl: '',
            },
            originPhoneNumber: '',
        }
    }

    UNSAFE_componentWillMount() {
        this.loadUser()
    }

    loadUser = () => {
        axios
            .get(`${BACKEND_HOST}/auth/me`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                console.log(res.data)
                const user = this.state.user
                user['email'] = res.data.email
                user['name'] = res.data.name
                user['phoneNumber'] = res.data.phoneNumber
                user['thumbnailUrl'] = res.data.thumbnailUrl

                this.setState({ user, originPhoneNumber: res.data.phoneNumber })
                console.log(res.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }

    sendData = (event) => {
        event.preventDefault()

        let data
        if (this.state.user.password !== '') {
            data = {
                // email: this.state.user.email,
                thumbnailUrl: this.state.user.thumbnailUrl,
                phoneNumber: this.state.user.phoneNumber,
                password: this.state.user.password,
                name: this.state.user.name,
                marketingAgree: true,
            }
        } else {
            data = {
                // email: this.state.user.email,
                thumbnailUrl: this.state.user.thumbnailUrl,
                phoneNumber: this.state.user.phoneNumber,
                name: this.state.user.name,
                marketingAgree: true,
            }
        }

        axios
            .patch(`${BACKEND_HOST}/auth/me`, data, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                console.log(res)
                const user = this.state.user
                user['password'] = ''
                user['passwordConfirm'] = ''

                this.setState({ user })
                alert('정보수정이 완료되었습니다.')
            })
            .catch((err) => {
                console.log(err)
            })
    }

    changeUser = (event) => {
        const field = event.target.name
        const user = this.state.user
        user[field] = event.target.value

        this.setState({
            user,
        })
    }

    handleProfile = (img) => {
        const user = this.state.user
        console.log(img)
        user['thumbnailUrl'] = img[0].url

        this.setState({
            user,
        })
    }

    render() {
        console.log(this.state)

        return (
            <div>
                {this.props.cookies.get('project') ? <HeaderMenu /> : <HeaderProject />}

                <div
                    className={
                        this.props.cookies.get('token') && this.props.cookies.get('project')
                            ? 'section_wrap section_wrap_menu'
                            : 'section_wrap'
                    }>
                    <div
                        className={
                            this.props.cookies.get('project')
                                ? 'mypage_wrap common_detail'
                                : 'mypage_wrap common_detail mypage_wrap_n'
                        }>
                        <MyPageForm
                            onSubmit={this.sendData}
                            onChange={this.changeUser}
                            handleProfile={this.handleProfile}
                            user={this.state.user}
                            originPhoneNumber={this.state.originPhoneNumber}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default withCookies(MyPage)



// WEBPACK FOOTER //
// ./Src/Containers/User/MyPage.js